// src/utils/sendUsdtPayment.js

import { createPublicClient, parseUnits, parseAbi, http } from "viem";
import { bsc } from "viem/chains";

const USDT_CONTRACT = process.env.REACT_APP_USDT_CONTRACT;
const RECEIVER = process.env.REACT_APP_USDT_RECEIVER;
const BSC_RPC_URL = process.env.REACT_APP_BSC_RPC_URL;

// ⬇️ NEW: ticket price + decimals via env (defaults match BSC USDT = 18)
const TICKET_PRICE_USDT = Number(
  process.env.REACT_APP_TICKET_PRICE_USDT || "1"
);
const USDT_DECIMALS = Number(process.env.REACT_APP_USDT_DECIMALS || "18");

const USDT_ABI = parseAbi([
  // only what we actually use
  "function transfer(address to, uint256 amount) returns (bool)",
]);

export async function sendUsdtPayment({
  walletClient,
  walletAddress,
  quantity,
}) {
  if (!walletClient || !walletAddress) {
    throw new Error("Wallet not ready. Please reconnect.");
  }
  if (!USDT_CONTRACT || !RECEIVER) {
    throw new Error("Missing USDT contract or receiver address");
  }
  if (!Number.isInteger(quantity) || quantity <= 0) {
    throw new Error("Quantity must be a positive integer (tickets count).");
  }

  const publicClient = createPublicClient({
    chain: bsc,
    transport: http(BSC_RPC_URL),
  });

  // amount = ticket_price * quantity
  const totalUsdt = (TICKET_PRICE_USDT * quantity).toString();
  const amount = parseUnits(totalUsdt, USDT_DECIMALS);

  try {
    console.log(`📤 Sending ${totalUsdt} USDT for ${quantity} tickets...`);

    const txHash = await walletClient.writeContract({
      address: USDT_CONTRACT,
      abi: USDT_ABI,
      functionName: "transfer",
      args: [RECEIVER, amount],
      account: walletAddress,
      chain: bsc, // keep chain explicit to avoid mismatches
    });

    console.log("✅ Transfer txHash:", txHash);
    return txHash;
  } catch (e) {
    console.error("🛑 USDT Payment Error:", e);
    throw new Error(
      e?.shortMessage ||
        e?.message ||
        "Payment transaction failed. Please try again."
    );
  }
}
